import React from 'react';
import { Link } from 'react-router-dom';
import SurveyResponsePage from '../SurveyResponsePage';
import { percorsiArea } from '../../services/surveyAuth';

/**
 * Pagina pubblica del link ricevuto per email dai rappresentanti
 * (`/sondaggi-rappresentanti/:id#lt=<token>`): fuori da RepresentativePrivateRoute,
 * come `/sondaggi/:id` per gli studi. Niente shell dell'area associativa (chi
 * apre il link può non avere effettuato l'accesso): una testata minima e la
 * pagina di risposta dell'area associativa, che legge il link firmato e, se
 * c'è, usa il Bearer rappresentante.
 */
const RappresentanteSurveyLinkPage: React.FC = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
    <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <span className="text-sm font-semibold text-gray-900 dark:text-white">UNASCA · Area associativa</span>
        <Link
          to={percorsiArea('associativa').elenco}
          className="text-sm font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
        >
          Vai all'area associativa
        </Link>
      </div>
    </header>
    <SurveyResponsePage area="associativa" />
  </div>
);

export default RappresentanteSurveyLinkPage;
